/** 
 * 価格情報を保持
 * 
 */
export class DetailInfoModel {
  /** 適用開始企画回 */
  applicableStartCatalog: string = <string>'';
  /** 適用終了企画回 */
  applicableEndCatalog: string = <string>'';
  /** 
   * 配達休止フラグ 
   * 0: false 1:true */
  pauseDelivery: string = <string>'';
  /** 
   * 値引区分 
   * 1:値引単価 2:値引率 */
  discountType: string = <string>'1';
  /** 値引単価 */
  discountUnitPrice: string = <string>'';
  /** 値引率 */
  discountRate: string = <string>'';
  /** 値引き後供給単価 */
  discountPrice: string = <string>'';
  /** 専用商品名 */
  rememberGoodsName: string = <string>'';
  /** 専用商品名(カナ) */
  rememberGoodsNameKana: string = <string>'';
  /** 専用規格名 */
  rememberStandardName: string = <string>'';
  /** 専用規格名(カナ) */
  rememberStandardNameKana: string = <string>'';
}